/* House of Merch — Zukunft
 *
 * Drei Dinge, sonst nichts:
 *   1. die Hologramm-Buehne im Kopfbereich
 *   2. Abschnitte, die beim Hereinscrollen aufgehen
 *   3. die Uhr bis zum Album
 *
 * Kein Framework, keine fremde Datei. Ein Laden, der nicht laedt, weil ein
 * Rechenzentrum in Kalifornien hustet, ist ein geschlossener Laden.
 *
 * Alles laeuft hinter `try`: Faellt der Effekt aus, bleibt die Seite ganz.
 * Und wer "Bewegung reduzieren" eingestellt hat, bekommt ein Standbild.
 */
(function () {
  "use strict";

  var ruhig = window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ------------------------------------------------------------ Buehne */
  function buehne(leinwand) {
    var g = leinwand.getContext("2d");
    if (!g) return;

    var B = 0, H = 0, dpr = Math.min(window.devicePixelRatio || 1, 2);
    var t = 0, scrollAnteil = 0, laeuft = true;

    /* Sterne: einmal gewuerfelt, dann nur noch verschoben. Jeden Bild
     * neu zu wuerfeln ergibt Rauschen, keinen Raum. */
    var sterne = [];
    function sterneSetzen() {
      sterne.length = 0;
      var n = Math.min(150, Math.round((B * H) / 26000));
      for (var i = 0; i < n; i++) {
        sterne.push({
          x: Math.random(), y: Math.random() * 0.62,
          r: Math.random() * 1.5 + 0.3,
          f: Math.random() * 0.8 + 0.2,
          p: Math.random() * 6.283
        });
      }
    }

    function messen() {
      var r = leinwand.getBoundingClientRect();
      B = Math.max(1, Math.round(r.width));
      H = Math.max(1, Math.round(r.height));
      leinwand.width = Math.round(B * dpr);
      leinwand.height = Math.round(H * dpr);
      g.setTransform(dpr, 0, 0, dpr, 0, 0);
      sterneSetzen();
    }

    /* Der Boden: Linien, die auf einen Fluchtpunkt zulaufen. Die Quer-
     * linien wandern auf den Betrachter zu — daher der Sog. */
    function boden() {
      var hy = H * (0.46 + scrollAnteil * 0.06);   // Horizont
      var fx = B / 2;
      var tiefe = H - hy;

      g.lineWidth = 1;

      for (var i = -22; i <= 22; i++) {
        var weite = i * (B / 13);
        var a = 1 - Math.min(1, Math.abs(i) / 20);
        g.strokeStyle = "rgba(198,162,84," + (0.028 + a * 0.10).toFixed(3) + ")";
        g.beginPath();
        g.moveTo(fx + weite * 0.045, hy);
        g.lineTo(fx + weite * 3.4, H + 60);
        g.stroke();
      }

      for (var j = 0; j < 26; j++) {
        var s = ((j + (t * 0.055) % 1) / 26);
        var y = hy + tiefe * Math.pow(s, 2.35);
        if (y < hy || y > H + 40) continue;
        var b = Math.pow(s, 1.2);
        g.strokeStyle = "rgba(198,162,84," + (0.03 + b * 0.16).toFixed(3) + ")";
        g.beginPath(); g.moveTo(-40, y); g.lineTo(B + 40, y); g.stroke();
      }

      var glut = g.createLinearGradient(0, hy - 90, 0, hy + 30);
      glut.addColorStop(0, "rgba(198,162,84,0)");
      glut.addColorStop(0.72, "rgba(198,162,84,.14)");
      glut.addColorStop(1, "rgba(236,206,140,.05)");
      g.fillStyle = glut;
      g.fillRect(0, hy - 90, B, 120);
    }

    function himmel() {
      for (var i = 0; i < sterne.length; i++) {
        var s = sterne[i];
        var fl = 0.35 + 0.65 * (0.5 + 0.5 * Math.sin(t * s.f * 0.9 + s.p));
        g.fillStyle = "rgba(236,206,140," + (fl * 0.5).toFixed(3) + ")";
        g.beginPath();
        g.arc(s.x * B, s.y * H - scrollAnteil * 40, s.r, 0, 6.2832);
        g.fill();
      }
    }

    /* Der Ring: das einzige „Objekt" im Raum. Ellipsen in Schraeglage, die
     * sich drehen — genug fuer Raumgefuehl, wenig genug fuers Handy. */
    function ring() {
      var cx = B / 2, cy = H * (0.44 + scrollAnteil * 0.04);
      var r = Math.min(B, H) * 0.30;
      for (var k = 0; k < 3; k++) {
        var dreh = t * (0.16 + k * 0.05) + k * 1.1;
        var stauch = 0.30 + 0.16 * Math.sin(t * 0.22 + k);
        g.save();
        g.translate(cx, cy);
        g.rotate(dreh * 0.12);
        g.strokeStyle = "rgba(198,162,84," + (0.22 - k * 0.05).toFixed(3) + ")";
        g.lineWidth = 1.2;
        g.beginPath();
        g.ellipse(0, 0, r * (1 + k * 0.13), r * stauch, 0, 0, 6.2832);
        g.stroke();
        g.restore();
      }
    }

    function bild() {
      if (!laeuft) return;
      t += ruhig ? 0 : 0.016;
      g.clearRect(0, 0, B, H);
      himmel();
      ring();
      boden();
      if (!ruhig) requestAnimationFrame(bild);
    }

    messen();
    window.addEventListener("resize", function () {
      clearTimeout(buehne._z);
      buehne._z = setTimeout(messen, 180);
    });

    /* Ausserhalb des Bildes nicht rechnen — spart Akku auf dem Handy. */
    if (window.IntersectionObserver) {
      new IntersectionObserver(function (e) {
        var sichtbar = e[0].isIntersecting;
        if (sichtbar && !laeuft) { laeuft = true; bild(); }
        laeuft = sichtbar;
      }, { threshold: 0 }).observe(leinwand);
    }

    if (!ruhig) {
      window.addEventListener("scroll", function () {
        var r = leinwand.getBoundingClientRect();
        scrollAnteil = Math.min(1, Math.max(0, -r.top / Math.max(1, r.height)));
      }, { passive: true });
    }

    bild();
  }

  /* --------------------------------------------------------- Einblenden */
  function einblenden() {
    var teile = document.querySelectorAll(".hoa-auf");
    if (!teile.length) return;
    if (!window.IntersectionObserver || ruhig) {
      for (var i = 0; i < teile.length; i++) teile[i].classList.add("hoa-da");
      return;
    }
    var w = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("hoa-da"); w.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
    for (var j = 0; j < teile.length; j++) w.observe(teile[j]);
  }

  /* ---------------------------------------------------------------- Uhr */
  function uhr(kasten) {
    var ziel = new Date(kasten.getAttribute("data-bis"));
    if (isNaN(ziel.getTime())) return;
    var felder = kasten.querySelectorAll("strong");
    if (felder.length < 4) return;
    function schlag() {
      var d = Math.max(0, ziel.getTime() - Date.now());
      var tage = Math.floor(d / 864e5);
      var std = Math.floor(d / 36e5) % 24;
      var min = Math.floor(d / 6e4) % 60;
      var sek = Math.floor(d / 1e3) % 60;
      var w = [tage, std, min, sek];
      for (var i = 0; i < 4; i++) {
        var s = (i === 0 ? String(w[i]) : ("0" + w[i]).slice(-2));
        if (felder[i].textContent !== s) felder[i].textContent = s;
      }
    }
    schlag();
    setInterval(schlag, 1000);
  }

  function los() {
    try {
      var l = document.querySelector("[data-hoa-buehne]");
      if (l) buehne(l);
    } catch (e) { /* Effekt weg, Seite bleibt */ }
    try { einblenden(); } catch (e) {}
    try {
      var u = document.querySelectorAll("[data-bis]");
      for (var i = 0; i < u.length; i++) uhr(u[i]);
    } catch (e) {}
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", los);
  } else { los(); }
})();
